import React from 'react'
import "./WhyChooseUs.css"

const WhyChooseData = [
    {
        icon:"/images/icons/why-choose-icon-1.svg",
        title:`<h4 class='color-white' style={{fontWeight:"700"}}>Expert<br> Guidance</h4>` ,
        content:"Professional accountants with years of experience."
    },
    {
        icon:"/images/icons/why-choose-icon-2.svg",
        title:`<h4 class='color-white' style={{fontWeight:"700"}}>Personalized <br> Service</h4>`,
        content:"Solutions tailored to your business needs."
    },
    {
        icon:"/images/icons/why-choose-icon-3.svg",
        title:`<h4 class='color-white' style={{fontWeight:"700"}}>Reliable &<br> Transparent</h4> `,
        content:"Ethical and proactive financial management."
    },
    {
        icon:"/images/icons/why-choose-icon-4.svg",
        title:` <h4 class='color-white' style={{fontWeight:"700"}}>One-Stop<br> Solution</h4> `,
        content:"Comprehensive accounting, tax, and advisory services."
    },
]

function WhyChooseUs({
    heading="Why Choose Lotus Accounting?",
    cardData=WhyChooseData,
    rowGridSize=3,
    doubledRow=false
}) {
  return (
    <div className='WhyChooseUs-container standard-padding-space'>
        <div className='container py-4'>
            <div className='text-content text-center '>
                <h3 className='body-heading color-white'>{heading} </h3>

            </div>
            <div className={`row mt-5 ${doubledRow?"gy-lg-4":"gy-lg-0"}  gy-3 justify-content-center`}>
                {
                    cardData.map((ele)=>{
                        return(
                            <div className={`col-lg-${rowGridSize}`}>
                                <div className='reason-card text-center px-lg-4'>
                                    <img loading="lazy" src={ele.icon} alt='reason icon' className='mb-3 card-icon'/>
                                    {/* <h4 className='color-white' style={{fontWeight:"700"}}>{ele.title}</h4> */}
                                    <div dangerouslySetInnerHTML={{__html:ele.title}}></div>
                                    <p className='body-paragraph color-white'>{ele.content}</p>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    </div>
  )
}

export default WhyChooseUs